<template>
  <main class="min-h-screen bg-gray-50">
    <!-- Hero Section -->
    <section class="py-12 md:py-20 h-[500px]" ref="heroSection" :style="{ backgroundImage: `url(${require(`@/assets/contact.jpg`)})`, backgroundSize: 'cover', backgroundPosition: 'center' }">
    </section>

    <!-- Main Contact Info -->
    <section class="py-16 md:py-20" ref="contactSection">
      <div class="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <!-- Locations & Contact -->
        <div class="grid md:grid-cols-2 gap-8 mb-12">
          <!-- Location Section -->
          <div class="bg-white rounded-2xl shadow-lg p-8 md:p-10" :class="{ 'animate-slideInUp': contactVisible }" :style="contactVisible ? { 'animation-delay': '0s' } : {}">
            <div class="flex items-start">
              <div class="flex-shrink-0">
                <div class="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center">
                  <svg class="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/>
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"/>
                  </svg>
                </div>
              </div>
              <div class="ml-6">
                <div class="space-y-4 text-sm">
                  <div>
                    <p class="text-lg font-semibold text-red-600">Singapore</p>
                    <address class="not-italic">67 Ubi Crescent<br>#05-06 Singapore<br>408560</address>
                  </div>
                  <div>
                    <p class="text-lg font-semibold text-red-600">Malaysia</p>
                    <address class="not-italic">Unit 8-05, Level 8, Menara MBMR<br>1, Jalan Syed Putra,<br>58000 Kuala Lumpur</address>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Email Contact Section -->
          <div class="bg-white rounded-2xl shadow-lg p-8 md:p-10" :class="{ 'animate-slideInUp': contactVisible }" :style="contactVisible ? { 'animation-delay': '0.15s' } : {}">
            <div class="flex items-start">
              <div class="flex-shrink-0">
                <div class="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center">
                  <svg class="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
                  </svg>
                </div>
              </div>
              <div class="ml-6 flex-1">
                <h3 class="text-2xl font-bold text-gray-900">Contact Us</h3>
                <p class="text-sm text-gray-600 mb-4">We'd Love to Hear from You</p>
                <div class="space-y-3">
                  <div>
                    <p class="text-sm text-gray-600 mb-1">Sales Inquiries</p>
                    <a href="mailto:sales@mineits.com" class="text-red-600 hover:text-red-600 font-semibold transition">
                      sales@mineits.com
                    </a>
                  </div>
                  <div>
                    <p class="text-sm text-gray-600 mb-1">Support</p>
                    <a href="mailto:support@mineits.com" class="text-red-600 hover:text-red-600 font-semibold transition">
                      support@mineits.com
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  name: 'ContactPage',
  data() {
    return {
      heroVisible: false,
      contactVisible: false,
      sectionObserver: null,
      form: {
        name: '',
        company: '',
        email: '',
        phone: '',
        subject: '',
        message: ''
      },
      isSubmitting: false
    }
  },
  mounted() {
    this.setupSectionObserver()
  },
  beforeUnmount() {
    if (this.sectionObserver) {
      this.sectionObserver.disconnect()
    }
  },
  methods: {
    setupSectionObserver() {
      if (!('IntersectionObserver' in window)) {
        this.heroVisible = true
        this.contactVisible = true
        return
      }
      
      this.sectionObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              const ref = entry.target.getAttribute('data-section')
              if (ref === 'hero') this.heroVisible = true
              if (ref === 'contact') this.contactVisible = true
            }
          })
        },
        {
          threshold: 0.1,
          rootMargin: '0px 0px -50px 0px'
        }
      )
      
      if (this.$refs.heroSection) {
        this.$refs.heroSection.setAttribute('data-section', 'hero')
        this.sectionObserver.observe(this.$refs.heroSection)
      }
      if (this.$refs.contactSection) {
        this.$refs.contactSection.setAttribute('data-section', 'contact')
        this.sectionObserver.observe(this.$refs.contactSection)
      }
    },
    submitForm() {
      // Handle form submission
      this.isSubmitting = true
      
      // Simulate API call
      setTimeout(() => {
        alert('Thank you for your message! We will get back to you soon.')
        this.resetForm()
        this.isSubmitting = false
      }, 1500)
    },
    resetForm() {
      this.form = {
        name: '',
        company: '',
        email: '',
        phone: '',
        subject: '',
        message: ''
      }
    }
  }
}
</script>

<style scoped>
/* Fade In Animation */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.animate-fadeIn {
  animation: fadeIn 0.8s ease-in-out both;
}

/* Fade In Up Animation */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.animate-fadeInUp {
  animation: fadeInUp 0.8s ease-out both;
}

/* Slide In Up Animation */
@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.animate-slideInUp {
  animation: slideInUp 0.8s ease-out both;
}
</style>